const ns = {};

ns.HtmlEncodingDecodingHelper = function () {};

/**
 * Encodes the text in the value with html entities. The div is basically created in memory but is never appended to the document.
 * But with this div element we can call the html and text function of jquery to encode the string.
 *
 * @param value The string to encode.
 * @returns The encoded string.
 */
ns.HtmlEncodingDecodingHelper.prototype.encode = function (value) {
    return $('<div />').text(value).html();
};

/**
 * Decodes html entities in the value. The div is basically created in memory but is never appended to the document.
 * But with this div element we can call the html and text function of jquery to decode the string.
 *
 * @param value The encoded string (contains html entities e.g.).
 * @returns The decoded html string.
 */
ns.HtmlEncodingDecodingHelper.prototype.decode = function (value) {
    return $('<div />').html(value).text();
};

export default ns.HtmlEncodingDecodingHelper;
